import { appOptions } from "./appOptions";

const { apiPrefix } = appOptions;

export const getContentMetadataApi = (): string => {
	return `${appOptions.getContentPrefix()}/content_metadata.json`;
};

export const getFrontMatterApi = (frontMatterId: string): string => {
	return `${appOptions.getContentPrefix()}/front_matters/${frontMatterId}.json`;
};

export const getFigureApi = (figureId: string): string => {
	return `${appOptions.getContentPrefix()}/figures/${figureId}.json`;
};

export const getTableApi = (tableId: string): string => {
	return `${appOptions.getContentPrefix()}/tables/${tableId}.json`;
};

export const getTopicApi = (chapterId: string): string => {
	return `${appOptions.getContentPrefix()}/topics/${chapterId}.json`;
};

export const getQuestionApi = (questionId: string): string => {
	return `${appOptions.getContentPrefix()}/questions/${questionId}.json`;
};

export const getBookQuestionsApi = (bookId: string): string => {
	return `${appOptions.getContentPrefix()}/questions/by_book/${bookId}.json`;
};

export const getSyncApi = (): string => {
	return `${apiPrefix}/sync.json`;
};

export const getQuizResponsesApi = (quizId: string): string => {
	return `${apiPrefix}/quizzes/${quizId}/responses.json`;
};

export const getQuizApi = (quizId: string): string => {
	return `${apiPrefix}/quizzes/${quizId}.json`;
};

export const createQuizApi = (): string => {
	return `${apiPrefix}/quizzes.json`;
};

export const updateQuizApi = (quizId: number | string): string => {
	return `${apiPrefix}/quizzes/${quizId}.json`;
};

export const deleteQuizApi = (quizId: number | string): string => {
	return `${apiPrefix}/quizzes/${quizId}.json`;
};

export const getHighlightsApi = (): string => {
	return `${apiPrefix}/highlights.json`;
};

export const updateHighlightApi = (highlightId: number): string => {
	return `${apiPrefix}/highlights/${highlightId}.json`;
};

export const deleteHighlightApi = (highlightId: number): string => {
	return `${apiPrefix}/highlights/${highlightId}.json`;
};

export const dismissInvalidatedHighlightsAlertApi = (): string => {
	return `${apiPrefix}/highlights/dismiss_invalidated_alert.json`;
};

export const getHighlightableNodesApi = (): string => {
	return `${apiPrefix}/highlights/highlightable_nodes_for_hl_ids.json`;
};

export const getSearchApi = (queryStr: string): string => {
	return `${apiPrefix}/search.json?${queryStr}`;
};
